import React, { FC, useEffect, useRef, useState } from 'react';
import { useField } from 'formik';
import cn from 'classnames';

import css from './SMSOTPForm.module.scss';

interface Props {
  isResendedCode: boolean;
}

const SMSOTPForm: FC<Props> = ({ isResendedCode }) => {
  const [digits, setDigits] = useState<string[]>(new Array(6).fill(''));
  const digitsRef = useRef<Array<string>>(new Array(6).fill(''));
  const [activeFieldIndex, setActiveFieldIndex] = useState<number>(0);
  const inputRef = useRef<HTMLInputElement>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helpers] = useField('code');

  const isError: boolean = meta.touched && !!meta.error;

  const processInputChange = (index: number, eventValue: string) => {
    const value = eventValue[0] ?? '';
    const digits = digitsRef.current;
    const newState: string[] = [...digits];

    newState[index] = value;

    if (!value) {
      newState[index] = '';
      setActiveFieldIndex(index - 1);
    } else if (activeFieldIndex < digits.length - 1) {
      setActiveFieldIndex(index + 1);
    }

    setDigits(newState);
    digitsRef.current = newState;

    if (eventValue.length > 1 && index < 5) {
      processInputChange(index + 1, eventValue.slice(1));
    }
  };

  const onDigitChange =
    (index: number) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
      processInputChange(index, e.target.value);
    };

  const joinDigits = (): string => {
    const result: string = Object.values(digits).reduce((value: string, total: string) => {
      return (total = value + total);
    }, '');

    return result;
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeFieldIndex]);

  useEffect(() => {
    helpers.setValue(joinDigits());

    if (!joinDigits()) {
      setActiveFieldIndex(0);
    }
  }, [joinDigits()]);

  useEffect(() => {
    if (isResendedCode) {
      setDigits(new Array(6).fill(''));
      digitsRef.current = new Array(6).fill('');

      setActiveFieldIndex(0);
      helpers.setTouched(false);
    }
  }, [isResendedCode]);

  return (
    <div className={cn(css.container, isError && css.error)}>
      {digits.map((value, index) => {
        return (
          <input
            ref={activeFieldIndex === index ? inputRef : null}
            name={value}
            tabIndex={index}
            onChange={onDigitChange(index)}
            value={value}
            key={`${value}/${index}`}
            type="number"
            pattern="[0-9]*"
            inputMode="numeric"
          />
        );
      })}
    </div>
  );
};

export default SMSOTPForm;
